import { render, staticRenderFns } from "./ProductFeatures.vue?vue&type=template&id=73edf579&scoped=true&"
import script from "./ProductFeatures.vue?vue&type=script&lang=js&"
export * from "./ProductFeatures.vue?vue&type=script&lang=js&"
import style0 from "./ProductFeatures.vue?vue&type=style&index=0&id=73edf579&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73edf579",
  null
  
)

export default component.exports